module.exports = __webpack_public_path__ + "static/media/2_pl.1b73633f.png";